import { Component } from "react";

// Admin paneli hata sınırı — render patlarsa beyaz ekran yerine kurtarma ekranı gösterir.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div data-testid="admin-error-boundary" className="min-h-[50vh] flex flex-col items-center justify-center gap-4 p-8 text-center">
          <p className="font-serif text-2xl text-forest">Bir şeyler ters gitti</p>
          <p className="text-sm text-stone-500 max-w-md break-words">{String(this.state.error?.message || this.state.error)}</p>
          <button onClick={() => { this.setState({ error: null }); window.location.reload(); }} className="bg-forest hover:bg-forest-dark text-white text-sm font-semibold px-5 py-2.5 rounded-xl transition-colors">Sayfayı Yenile</button>
        </div>
      );
    }
    return this.props.children;
  }
}
